<li
  [class.open]="showNavItem() === 'show'"
  (transitionend)="onNavItemSlideEnd($event)"
  class="mobile-nav-item"
  data-cy="mobileNavigationMenuItem"
>
  @if (!link()?.linkExternalUrl) {
    <a
      href="#"
      [class]="link()?.linkClasses"
      [attr.aria-label]="link()?.linkText"
      [attr.data-cy]="link()?.mobileLinkTestId"
      (click)="linkClick($event)"
      (blur)="onLinkBlur()"
    >
      <div class="mobile-nav-item-link">
        <div class="mobile-link-content">
          @if (!!link()?.linkIcon) {
            <span
              class="link-content-icon"
              role="img"
              alt=""
              [attr.title]="link()?.linkText"
              [ngClass]="link()?.linkIcon"
            ></span>
          }
          <span [class.overflow-ellipsis]="link()?.overflowEllipsis" class="link-text">{{
            link()?.linkText
          }}</span>
          @if (!!link()?.subLinkArray?.length) {
            <span role="presentation" class="icon-chevron-right link-content-children-icon"></span>
          }
        </div>
      </div>
    </a>
  }
  @if (!!link()?.linkExternalUrl) {
    <a
      [href]="link()?.linkExternalUrl"
      [class]="link()?.linkClasses"
      [href]="link()?.linkExternalUrl"
      [attr.aria-label]="link()?.linkText"
      [attr.target]="link()?.linkTarget"
      [attr.data-cy]="link()?.mobileLinkTestId"
      (click)="linkClick($event)"
      (blur)="onLinkBlur()"
    >
      <div class="mobile-link-content">
        @if (!!link()?.linkIcon) {
          <span
            class="link-content-icon"
            role="img"
            alt=""
            [attr.title]="link()?.linkText"
            [ngClass]="link()?.linkIcon"
          ></span>
        }
        <span [class.overflow-ellipsis]="link()?.overflowEllipsis" class="link-text">{{
          link()?.linkText
        }}</span>
      </div>
    </a>
  }
</li>
@if (!!link()?.subLinkArray?.length) {
  <ul
    class="mobile-subnav"
    [class.open]="showSub() === 'show'"
    (transitionend)="onSubmenuSlideEnd($event)"
    [attr.data-cy]="link()?.mobileSubmenuTestId"
  >
    <li class="mobile-subnav-title">
      <a #sublinkTitle href="#" (click)="sublinkTitleClick($event)">
        <span class="icon-chevron-left pad-right-10 icon"></span>
        <span>{{ link()?.mobileAltSubMenuTitle || link()?.linkText }}</span>
      </a>
    </li>
    @for (sublink of link()?.subLinkArray; track $index) {
      @if (sublink.linkText) {
        <li
          #subLinkElemItem
          class="mobile-subnav-item"
          [class]="sublink?.listClasses"
          [style.maxWidth.px]="sublink?.maxWidth"
          (blur)="resetOnBlur($any($event.currentTarget).parent)"
        >
          @if (!sublink?.linkExternalUrl) {
            <a
              href="#"
              [class]="sublink?.linkClasses"
              [dsRouterLink]="sublink?.linkRoute"
              [queryParams]="sublink?.queryParams"
              [attr.aria-label]="sublink?.linkText"
              [attr.data-cy]="sublink?.mobileLinkTestId"
              (click)="sublinkClick(sublink, $event)"
              (blur)="resetOnBlur($any($event.currentTarget).parentNode)"
            >
              <div class="mobile-link-content" [class.noMargin]="link()?.linkType === 'contactUs'">
                @if (!!sublink?.linkIcon) {
                  <span
                    class="link-content-icon"
                    role="img"
                    alt="Link Icon"
                    [attr.title]="sublink?.linkText"
                    [ngClass]="sublink?.linkIcon"
                  ></span>
                }
                @if (sublink.subLinkType === 'weekday' || sublink.subLinkType === 'weekend') {
                  <span
                    [class.overflow-ellipsis]="sublink?.overflowEllipsis"
                    class="link-text"
                    [class.hours]="link()?.linkType === 'contactUs'"
                  >
                    {{ sublink.linkText }}
                  </span>
                } @else {
                  <span [class.overflow-ellipsis]="sublink?.overflowEllipsis" class="link-text">{{
                    sublink.linkText
                  }}</span>
                }
              </div>
            </a>
          }
          @if (!!sublink?.linkExternalUrl) {
            <a
              [class]="sublink?.linkClasses"
              [href]="sublink?.linkExternalUrl"
              [attr.aria-label]="sublink?.linkText"
              [attr.target]="sublink?.linkTarget"
              [attr.data-cy]="sublink?.mobileLinkTestId"
              (click)="sublinkClick(sublink, $event)"
              (blur)="resetOnBlur($any($event.currentTarget).parentNode)"
            >
              <div class="mobile-link-content" [class.phone]="link()?.linkType === 'contactUs'">
                @if (!!sublink?.linkIcon) {
                  <span
                    role="img"
                    alt="Link Icon"
                    [attr.title]="sublink?.linkText"
                    class="icon-call link-content-icon"
                    [class.icon]="link()?.linkType === 'contactUs'"
                  ></span>
                }
                <span [class.overflow-ellipsis]="sublink?.overflowEllipsis" class="link-text">{{
                  sublink.linkText
                }}</span>
              </div>
            </a>
          }
        </li>
        @if (sublink?.dividerAfter) {
          <hr aria-hidden="true" class="mobile-subnav-divider" />
        }
      }
    }
  </ul>
}
